export const MBtoGB = (number) => {
	return number/1024;
};

export const MBtoKB = (number) => {
	return number*1024*1024;
};

export const KBtoGB = (number) => {
	return number/1024/1024/1024;
};

export const toBytes = (bytes, decimals) => {
	if (bytes === 0) {
		return '0 Bytes';
	}

	const k = 1024;
	const dm = decimals || 2;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const i = Math.floor(Math.log(bytes) / Math.log(k));
	
	return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const getPercentage = (current, total) => {
	return `${+((current / total) * 100).toFixed(2).split('.')[0]}`
}

export const forceLowerCase = (value) => {
	if (!value) {
		return value;
	};

	return value.toLowerCase();
}

export const getFormattedError = (error) => {
	const formattedError = {
		statusCode: null,
		errorCode: null,
		summarizedRequest: null,
		url: null,
		requestData: null,
	}

	if (!error.response) {
		formattedError.statusCode = "502/504"
		formattedError.errorCode = "SERVERDOWN/TIMEOUT"
	} else if (error.response.data) {
		formattedError.statusCode = error.response.status
		formattedError.errorCode = (error.response.data.error || "").toUpperCase()
	}

	const getSummarizedRequest = (error) => {
		const baseURL = error.config.baseURL || ""
		const url = error.config.url || ""
		const method = (error.config.method || "").toUpperCase()

		const path = url.split(baseURL).pop()

		return `${method} ${path}`
	}

	formattedError.summarizedRequest = getSummarizedRequest(error)
	formattedError.url = error.config && error.config.url
	formattedError.requestData = error.config && error.config.data

	const encodedErrorParams = []
	encodedErrorParams.push(formattedError.statusCode)
	encodedErrorParams.push(formattedError.errorCode)
	encodedErrorParams.push(formattedError.summarizedRequest)
	
	const summarizedError = encodedErrorParams.join(" - ")

	const base64EncodedData = btoa(summarizedError)

	return {
		...formattedError,
		base64EncodedData,
		summarizedError
	}
}